import { Punkter } from "./Punkter";
import "./Punkter.scss";

export default Punkter;
